import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from '@material-tailwind/react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ApplyFreeTrialResponse } from '../../../../constants/types/free-trial/type';
import {
  copulaParticle,
  formatKstDateWithWeekday,
  removeSurname,
} from '../../../../api/utils/util-func';
import FreeTrialAttentionEffect from '../../../../components/free-trial/FreeTrialAttentionEffect';

const FreeTrialComplete = () => {
  const navigate = useNavigate();

  const { state } = useLocation();

  const trialInfo = state as Omit<
    ApplyFreeTrialResponse,
    'applicationId' | 'linkToken'
  > | null;

  if (!trialInfo) {
    return <Navigate to="/" replace />;
  }

  const handleClickStart = () => {
    navigate('/free-trial/lesson');
  };

  return (
    <div className="min-h-[calc(100dvh-58px)] bg-white px-5 pt-6 xl:bg-gray0">
      <div className="w-full xl:mx-auto xl:w-[580px] xl:px-0 xl:py-[30px]">
        <Card className="mb-[27px] mt-0 rounded-none shadow-none xl:min-h-[650px] xl:rounded-[20px] xl:shadow-card">
          <CardBody className="flex flex-col items-center px-0 pb-0 pt-8 xl:px-[32px] xl:pt-[48px]">
            {/* 마스코트 */}
            <div className="flex h-[120px] w-[120px] items-center justify-center overflow-hidden rounded-full bg-[#FFF7D6] xl:h-[140px] xl:w-[140px]">
              <img
                src="/images/free-trial/bready.png"
                alt="bready"
                className="h-full w-full object-contain"
              />
            </div>

            {/* 완료 문구 */}
            <Typography className="mt-6 text-center text-[24px] font-extrabold leading-[1.35] text-gray-900 xl:text-[26px]">
              {copulaParticle(removeSurname(trialInfo.childName))}의 무료체험이
              <br />
              준비됐어요!
            </Typography>

            {/* 신청 정보 */}
            <div className="mt-7 w-full rounded-2xl bg-[#F7F5FC] px-5 py-5">
              <div className="flex items-center justify-between">
                <Typography className="text-[13px] font-medium text-gray-700">
                  체험 과목
                </Typography>

                <Typography className="text-[13px] font-bold text-gray-900">
                  {trialInfo.subjectLabel}
                </Typography>
              </div>

              <div className="mt-3 flex items-center justify-between">
                <Typography className="text-[13px] font-medium text-gray-700">
                  이용 기간
                </Typography>

                <Typography className="text-right text-[13px] font-bold text-gray-900">
                  {formatKstDateWithWeekday()} ~{' '}
                  {formatKstDateWithWeekday(trialInfo.expireAt, {
                    showTime: true,
                  })}
                </Typography>
              </div>

              <div className="mt-3 flex items-center justify-between">
                <Typography className="text-[13px] font-medium text-gray-700">
                  신청 회차
                </Typography>

                <Typography className="text-[13px] font-bold text-gray-900">
                  {`${2 - trialInfo.remainingApplications}회차 (남은 신청 ${trialInfo.remainingApplications}회)`}
                </Typography>
              </div>
            </div>

            {/* 안내 */}
            <Typography className="mt-7 text-center text-[13px] font-normal leading-6 text-gray-700">
              카카오 알림톡으로 체험 링크를 보냈어요.
              <br />
              기간 안에는 언제든 링크로 이어서 할 수 있어요.
            </Typography>
          </CardBody>

          <CardFooter className="mt-auto px-0 pb-0 pt-8 xl:px-[32px] xl:pb-[32px]">
            <Button
              ripple={false}
              onClick={handleClickStart}
              className="relative h-12 w-full rounded-xl bg-[#6737F4] py-0 text-[15px] font-bold normal-case text-white shadow-none hover:bg-[#5D2EE7] hover:shadow-none focus:shadow-none"
            >
              <FreeTrialAttentionEffect />

              <span className="relative z-10">지금 바로 시작하기</span>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

export default FreeTrialComplete;
